import React from 'react';
import { Card,CardHeader,CardContent, Box, FormLabel, withStyles, WithStyles, Button} from '@material-ui/core';
import { CardDetalleEnvioStyles } from '../../styles';
import { connect } from 'react-redux';
import { IGuia } from '../../interface/IGuia';
import { CardHeaderDetalleEnvio } from "./CardHeaderDetalleEnvio";
import { finalizarChat,soporteAdicional } from '../../repository/ChatDao';
import { Confirmacion } from './Confirmacion';
import { finalizarChatEndPoint} from '../../repository/FinalizarDao';
import {ReportProblem,CancelScheduleSend,LiveHelp } from '@material-ui/icons';
import  imagenSporte  from "../../assets/live_help-24px.png";

interface CardDetalleProp extends WithStyles<typeof CardDetalleEnvioStyles> {
    guia:IGuia
    children?: React.ReactNode;
    className?: string;
  }

export const CardDetalleEnvioComponent = (props:CardDetalleProp) => {
  console.log(props.guia);
    const classes = props.classes;
    const [terminar, setFin] = React.useState(false);
    const [terminado, setFinalizado] = React.useState(false);
    const [soporte, setSoporte] = React.useState(false);
    const [soporteSolicitado, setSoporteSolicitado] = React.useState(false);
    const [asesorAsignado, setAsesorAsignado] = React.useState(false);


    const handleClose = () => {}

    const handleOpenFinalizar = () => {
      props.guia.estado !== 'FINALIZADO' ? setFin(true) : setFinalizado(true);
    }

    const handleOpenSoporteAdicional = () => {
      
      if(props.guia.estado === 'FINALIZADO'){
        handleOpenFinalizar();
      }else if(props.guia.soporte_adicional === true || props.guia.causal === '701' ){
        setSoporteSolicitado(true);
      } else if(props.guia.nombre_asesor){
        setAsesorAsignado(true);
       }else{
         setSoporte(true);
      }

    }

    const handCloseCerrarConfirmar = () => {
        setFin(false);
        setSoporte(false);
        setSoporteSolicitado(false);
        setFinalizado(false);
        setAsesorAsignado(false);
    }

    const handleFinalizar = () => {
        //finalizarChat(props.guia.guia);
        console.log("Finalizar");
        finalizarChatEndPoint(props.guia).then();
        setFin(false);
    }
    const handleSoporteAdicional = () => {
      soporteAdicional(props.guia).then()
      setSoporte(false);
    }

    return (
        <Box>
            <Box>
            <Box marginBottom="5px">
            <Card className = {classes.root} variant="outlined">
            <CardHeader className= {classes.header} title={<HeaderEmpleado/>} >

            </CardHeader>
            <CardContent className={classes.content}>
            {
                        (!props.guia.nombre_empleado || props.guia.nombre_empleado === '') ? 
                        ''
                        : 
                        <Box justifyContent="flex-start">
                          <FormLabel className={classes.label} > Repartidor: </FormLabel>
                          <FormLabel className={classes.nombres}>{' '+props.guia.nombre_empleado}</FormLabel>
                         </Box>
                }
               
                {
                        (!props.guia.nombre_asesor || props.guia.nombre_asesor === '') ? 
                        ''
                        : 
                        <Box justifyContent="flex-start">
                        <FormLabel className={classes.label} >Asesor:</FormLabel>
                        <FormLabel className={classes.nombres}>{' '+props.guia.nombre_asesor}</FormLabel>
                        </Box>
                }

            </CardContent>

            </Card>

            </Box>

            <Card className = {classes.root} variant="outlined">
            <CardHeader className= {classes.header}  title = {<CardHeaderDetalleEnvio  />}>

            </CardHeader>
            <CardContent className={classes.content}>
                <Box justifyContent="flex-start">
                    <FormLabel className={classes.label} >Fecha del envío: </FormLabel>
                    <FormLabel>{props.guia.fecha_envio}</FormLabel>
                </Box>
                <Box className={classes.contenedorInfo}>
                    <FormLabel className={classes.titulo}>Remitente</FormLabel>
                    <br/>
                    <FormLabel className={classes.data} >{props.guia.nombre_remitente}</FormLabel>
                    <br/>
                    <FormLabel className={classes.data}>{props.guia.direccion_remitente}</FormLabel>
                    <br/>
                    <FormLabel className={classes.label}>Tel: </FormLabel><FormLabel>{props.guia.telefono_remitente}</FormLabel>
                </Box>
                <Box className={classes.contenedorInfo}>
                    <FormLabel className={classes.titulo}>Destinatario</FormLabel>
                    <br/>
                    <FormLabel className={classes.data}>{props.guia.nombre_destinatario}</FormLabel>
                    <br/>
                    <FormLabel className={classes.data}>{props.guia.direccion_destinatario}</FormLabel>
                    <br/>
                    <FormLabel className={classes.label}>Tel: </FormLabel><FormLabel>{props.guia.telefono_destinatario}</FormLabel>
                </Box>
           
            </CardContent>
            
            </Card>
            </Box>
          <Box className={classes.boxBoton} display='grid'> 
              <Button className={classes.boton} onClick={()=>handleOpenSoporteAdicional()}>
                  <Box color={"#FF0000"}> <LiveHelp  color="inherit" height="25%"/></Box> 
                  <Box paddingLeft={1}>Solicitar Soporte Adicional</Box>
              </Button>
              <Button className={classes.boton} onClick={()=>handleOpenFinalizar()}>
               <CancelScheduleSend  height="25%"/>
               <Box paddingLeft={1}>Finalizar Chat</Box>
              </Button>
             
          </Box>
          <Box>
          <Confirmacion id='dialog' 
          open={terminar} 
          titulo='Finalizar Chat' 
          texto='¿Esta seguro que desea finalizar la conversación?'
          callbackCerrar={handleClose}
          callbackCerrarConfirm={handCloseCerrarConfirmar}
          callbackAceptarConfirm={handleFinalizar}
          bottonAceptar={true}
          />
          <Confirmacion id='dialog2' 
          open={soporte} 
          titulo='Solicitar Soporte Adicional' 
          texto='¿Esta seguro que desea solicitar soporte adicional?'
          callbackCerrar={handleClose}
          callbackCerrarConfirm={handCloseCerrarConfirmar}
          callbackAceptarConfirm={handleSoporteAdicional}
          bottonAceptar={true}
          />
          <Confirmacion id='dialog3' 
          open={soporteSolicitado} 
          titulo='' 
          texto='Ya se ha solicitado soporte adicional'
          callbackCerrar={handleClose}
          callbackCerrarConfirm={handCloseCerrarConfirmar}
          bottonAceptar={false}
          bottonAceptarCancelar={true}
          />
          <Confirmacion id='dialog4' 
          open={terminado} 
          titulo='Chat Finalizado' 
          texto='El chat se encuentra finalizado'
          callbackCerrar={handleClose}
          callbackCerrarConfirm={handCloseCerrarConfirmar}
          bottonAceptar={false}
          />
          <Confirmacion id='dialog5' 
          open={asesorAsignado} 
          titulo='' 
          texto='La guía tiene un asesor de servicio al cliente asignado'
          callbackCerrar={handleClose}
          callbackCerrarConfirm={handCloseCerrarConfirmar}
          bottonAceptar={false}
          bottonAceptarCancelar={true}
          />
          </Box>
       
        </Box>


        

    );
}

const HeaderEmpleado = () =>{
 return(
  <Box fontSize="14px" color="#6f6f71" fontWeight="bold">Empleado(s) encargado(s)</Box>
 );
}


const mapStateToProps = (state:any) => {
    return {
      guia: state.guiasReducer
    }
  }
  
  const mapDispatchToProps = () => ({})
  

export const CardDetalleEnvio = withStyles(CardDetalleEnvioStyles)(connect(mapStateToProps,mapDispatchToProps)(CardDetalleEnvioComponent))
 